import React from "react";
import ReactMarkdown from "react-markdown";

export default function NarrativeMdOutut({ narrative }: { narrative: string }) {
  const cleanNarrative = narrative
  .replace(/^```markdown\n/, '')
  .replace(/\n```$/, '')
  .trim();

  return (
    <div className="">
      <div className="font-['Plus_Jakarta_Sans'] text-sm text-gray-800 leading-relaxed">
        <ReactMarkdown
          components={{
            h1: ({node, ...props}) => <h1 className="text-2xl font-bold mt-4 mb-2" {...props} />,
            h2: ({node, ...props}) => <h2 className="text-xl font-semibold mt-4 mb-2" {...props} />,
            h3: ({node, ...props}) => <h3 className="text-lg font-semibold mt-3 mb-1" {...props} />,
            strong: ({node, ...props}) => <strong className="font-bold text-gray-900" {...props} />,
            p: ({node, ...props}) => <p className="mb-3" {...props} />,
            blockquote: ({node, ...props}) => (
              <blockquote className="border-l-4 border-gray-400 pl-4 italic text-gray-600 my-4" {...props} />
            ),
          }}
        >
          {cleanNarrative}
        </ReactMarkdown>
      </div>
    </div>
  );
}
